/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_DescriptionInputs */

const en_admin_invite_codes_delete_description = /** @type {(inputs: Admin_Invite_Codes_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone." |
*
* @param {Admin_Invite_Codes_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_description = /** @type {((inputs?: Admin_Invite_Codes_Delete_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_delete_description(inputs)
});
export { admin_invite_codes_delete_description as "admin.invite_codes.delete_description" }